<template>
  <Layout>
    <div class="section  content is-size-7 has-text-white">
      <p class="is-size-5 has-text-primary">Деактивиране</p>
      <p>
        Ако се откажете, ще задържа оставащите им абонаментни такси. 
      </p>
      <p>
        <input class="input m-r-sm" v-model="msisdn" placeholder="Формат: 600 700 800" style="max-width:480px;">
        <button class="button is-danger" @click="check">Продължи</button>
      </p>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/layouts/Kyf'

export default {
  name: 'Deactivation',
  components: {
    Layout
  },
  methods: {
    check() {
      confirm('Наистина ли искате да се отпишете от услугата?')
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/LangKyf/BG/Deactivation.vue